import { render, staticRenderFns } from "./filesIndex.vue?vue&type=template&id=6d1ad27a&"
import script from "./filesIndex.vue?vue&type=script&lang=js&"
export * from "./filesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports